import type { Mixpanel } from "./mixpanel-types.ts"

export const mixpanel = (globalThis as any).mixpanel as Mixpanel.Mixpanel
